const Tabs = (element) => {
  const el = {
    container: element.querySelectorAll(".tabs__wrapper"),
  };

  const method = {
    init: () => {
      el.container.forEach((tabContainer) => {
        // console.log(tabContainer);
        this.tabPanels = document.querySelectorAll("[role=tabpanel]");
        this.buttons = tabContainer.querySelectorAll("[role=tab]");
        this.activeTab = tabContainer.querySelector(
          "[role=tab][aria-selected=true]"
        );
        this.tablist = tabContainer.querySelector("[role=tablist]");
        // console.log(this.buttons);
        method.bind();
      });
    },

    setActiveTab: (e, button) => {
      const lastActiveElement = this.activeTab;

      lastActiveElement.setAttribute("aria-selected", "false");

      button.setAttribute("aria-selected", "true");

      this.activeTab = button;

      const lastPanelControl = lastActiveElement.getAttribute("aria-controls");

      // console.log(lastPanelControl);

      // console.log(this.tabPanels);

      if (lastPanelControl) {
        const lastPanel = Array.from(this.tabPanels).find(
          (x) => x.id === lastPanelControl
        );
        if (lastPanel) {
          lastPanel.setAttribute("aria-expanded", "false");
        } else {
          // console.log(this.tabPanels);
        }
      }

      const ariaControl = button.getAttribute("aria-controls");

      if (ariaControl) {
        const panel = Array.from(this.tabPanels).find(
          (x) => x.id === ariaControl
        );
        if (panel) {
          panel.setAttribute("aria-expanded", "true");
        } else {
          // console.log(panel);
        }
      }
      // set active
    },

    bind: () => {
      Array.prototype.map.call(this.buttons, (button) => {
        button.addEventListener(
          "click",
          (e) => method.setActiveTab(e, button),
          false
        );

        button.addEventListener("keyup", (e) => {
          if (e.keyCode == 13 || e.keyCode == 32) {
            // return or space
            e.preventDefault();
            method.setActiveTab(e, button);
          }
        });
      });

      this.tablist.addEventListener("keyup", (e) => {
        switch (e.keyCode) {
          case 35: // end key
            e.preventDefault();
            method.setActiveTab(e, this.buttons[this.buttons.length - 1]);
            break;
          case 36: // home key
            e.preventDefault();
            method.setActiveTab(e, this.buttons[0]);
            break;
          case 37: // left arrow
            e.preventDefault();
            let previous = [...this.buttons].indexOf(this.activeTab) - 1;
            previous = previous >= 0 ? previous : this.buttons.length - 1;
            method.setActiveTab(e, this.buttons[previous]);
            break;
          case 39: // right arrow
            e.preventDefault();
            let next = [...this.buttons].indexOf(this.activeTab) + 1;
            next = next < this.buttons.length ? next : 0;
            method.setActiveTab(e, this.buttons[next]);
            break;
          default:
            return;
        }
      });
    },
  };

  method.init();
};

export default Tabs;
